
import AppColorPicker from "@/components/ColorPicker.vue";
import { Calendar } from "@/models/calendar";
import { CalendarService } from "@/services/calendar-service";
import {pad} from "@/utils/numbers";
import Vue from "vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as() => Calendar,
			required: true
		}
	},
	computed: {
		editMode():boolean {
			if (this.value.ID == 0) {
				return false;
			}
			return true;
		},
		title():string {
			return this.$ct(this.editMode ? "edit-calendar" : "new-calendar").toString();
		},
		saveLabelKey():string {
			return this.editMode ? "common.save" : "common.create";
		},
		minTime():Date{
			let d = this.getZeroTime();
			if (!this.value.MinTime) return d;
			let [h,m] = this.value.MinTime.split(":");
			d.setHours(parseInt(h));
			d.setMinutes(parseInt(m));
			return d;
		},
		maxTime():Date{
			let d = this.getZeroTime();
			if (!this.value.MaxTime) return d;
			let [h,m] = this.value.MaxTime.split(":");
			d.setHours(parseInt(h));
			d.setMinutes(parseInt(m));
			return d;
		},
		isValid():boolean {
			if (this.value.MinTime == "00:00:00") return true;
			if (this.value.MaxTime == "00:00:00") return true;
			if (this.minTime > this.maxTime) return false;
			return true;
		}
	},
	methods: {
		getZeroTime():Date{
			let d = new Date(0);
			d.setHours(0);
			d.setMinutes(0);
			d.setSeconds(0);
			d.setMilliseconds(0);
			return d;
		},
		cancel() {
			this.$emit("close");
		},
		async save() {
			if (this.value.ID == 0) {
				var [cal] = await CalendarService.postCalendars([this.value]);
			} else {
				var [cal] = await CalendarService.putCalendars([this.value]);
			}
			this.$emit("input", cal);
			this.$emit("close");
		},
		setMinTime(val:Date){
			let h = val.getHours();
			let m = val.getMinutes();
			this.value.MinTime = `${pad(h, 2)}:${pad(m, 2)}:00`;
		},
		setMaxTime(val:Date){
			let h = val.getHours();
			let m = val.getMinutes();
			this.value.MaxTime = `${pad(h, 2)}:${pad(m, 2)}:00`;
		}
	},
	components: {
		AppColorPicker
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
